<template>
  <div
    class="d-flex align-items-stretch flex-column"
    style="flex: 1"
  >
    <base-list
      :items="contactItems"
      :loading="loading"
    >
      <template #loading>
        <base-skeleton
          v-for="n in 6"
          :key="`contact_skeleton__${n}`"
          class="d-flex"
        >
          <div class="col-4">
            <div
              class="skeleton__item"
              style="width: 83px; height: 83px;"
            />
          </div>
          <div class="col-5 align-self-center">
            <div class="skeleton__item w-75 pb-2" />
            <div class="skeleton__item w-75" />
          </div>
          <div class="col-3 align-self-center">
            <div class="skeleton__item w-50 pb-2" />
            <div class="skeleton__item w-50" />
          </div>
        </base-skeleton>
      </template>
      <template v-slot:nodata>
        <empty title="No Contact History yet">
          Create an Edit to start emailing your client!
        </empty>
      </template>
      <template v-slot:default="{item, index}">
        <div class="py-2">
          <out-reach-cell
            :item="item"
            @button-clicked="onButtonClicked(item)"
          />
        </div>
      </template>
    </base-list>
    <div
      v-if="count > pageSize"
      class="d-flex justify-content-center"
    >
      <BasePagination
        v-model="page"
        :count="count"
        :page-size="pageSize"
        @pageChange="pageChange"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Contacts',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    count: {
      // Total contacts count
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      pageSize: 6,
      page: 1,
    };
  },
  computed: {
    contactItems() {
      return this.items.map((item) => ({
        pk: item.outreach.pk,
        contact_type: item.display,
        events: this.formatEvents(item),
        backgroundImage: item.outreach.edit?.hero,
        time: item.time,
        subject: item.outreach.edit?.subject,
      }));
    },
  },
  methods: {
    formatEvents(item) {
      const events = [];
      if (item.display !== 'appointment') {
        if (item.display === 'email' || item.display === 'html' || item.display === 'wechat' || item.display === 'embed') {
          events.push({ label: 'Opens', value: item.opens });
        }
        events.push({ label: 'Clicks', value: item.clicks });
      } else {
        events.push({ label: 'Products', value: item.products.length });
        events.push({ label: 'Likes', value: item.likes.length });
      }
      return events;
    },
    /** Redirects to customer specific report view */
    onButtonClicked(item) {
      this.$router.push(`/clients/${this.$route.params.customerId}/outreach/${item.pk}/stats`);
    },
    pageChange(newpage) {
      this.page = newpage;
      this.$emit('page-change', {
        page: this.page,
        page_size: this.pageSize,
      });
    },
  },
};
</script>
<style scoped>
.clickable {
  cursor: pointer;
}
.gray-light {
  color: #aaaaaa;
}
</style>
